module.exports = __webpack_public_path__ + "img/estimate_letter.8ec3b39c.svg";